export default __webpack_public_path__ + "static/media/ourclient1.b8b6e071.png";